import {
  Box,
  getSize,
  Group,
  Input,
  InputLabelProps,
  Stack,
  Switch,
  SwitchProps,
  Text,
  Tooltip,
  TooltipProps,
  useMantineTheme,
} from '@mantine/core';
import clsx from 'clsx';
import { TooltipCard } from '../TooltipCard';
import classes from './VSwitch.module.css';

export interface VSwitchProps extends SwitchProps {
  invertLabelColor?: boolean;
  inputLabel?: string;
  inputLabelPosition?: 'left' | 'top';
  inputLabelProps?: InputLabelProps;
  tooltipText?: React.ReactNode;
  tooltipProps?: TooltipProps;
}

export function VSwitch({
  invertLabelColor = false,
  inputLabel,
  inputLabelPosition = 'left',
  inputLabelProps,
  size = 'sm',
  disabled,
  tooltipText,
  tooltipProps,
  ...props
}: VSwitchProps) {
  const theme = useMantineTheme();
  const Wrapper = inputLabelPosition === 'left' ? Group : Stack;

  const switchComponent = <Switch size={size} disabled={disabled} {...props} />;

  if (!inputLabel) {
    return tooltipText ? (
      <TooltipCard position="top-start" zIndex={1}>
        <TooltipCard.Target>
          <Box>{switchComponent}</Box>
        </TooltipCard.Target>
        <TooltipCard.Dropdown>
          <Text size="xs" fz={12} fw={400}>
            {tooltipText}
          </Text>
        </TooltipCard.Dropdown>
      </TooltipCard>
    ) : (
      switchComponent
    );
  }

  return (
    <Wrapper className={classes.vSwitch} data-position={inputLabelPosition}>
      <Input.Label
        className={clsx(classes.inputLabel, {
          [classes.inverted]: invertLabelColor,
          [classes.disabled]: disabled,
        })}
        size={getSize({ size, sizes: theme.fontSizes })}
        {...inputLabelProps}
      >
        {inputLabel}
      </Input.Label>

      {tooltipText ? (
        <Tooltip label={tooltipText} withinPortal={true} className={classes.vSwitchTooltip} {...tooltipProps}>
          <Box className={classes.vSwitchTooltipContainer}>{switchComponent}</Box>
        </Tooltip>
      ) : (
        switchComponent
      )}
    </Wrapper>
  );
}
